<template>
  <div class="trendsreport-pdf-component">
    <div
      v-if="cwa_data"
      class="trendsreport-pdf-component__content"
      :id="report.report_type.url"
    >
      <component
        :is="template"
        :cwaData="cwa_data"
        :title="report.report_type.name"
        :section="section"
        :publishDate="publishDate"
        :imagespath="app_url"
      />
    </div>
    <div
      v-else
      class="trendsreport-pdf-component__content"
      :id="report.report_type.url"
    >
      <component
        :is="template"
        :key="report.imagespath"
        v-bind:content="report.xml_content_json"
        :imagespath="`${app_url}/storage/${report.images_path}/`"
        :report="report"
        :section="section"
        :publishDate="publishDate"
      ></component>
    </div>
  </div>
</template>

<script>
  import { computed, defineAsyncComponent } from 'vue';
  import moment from 'moment';

  const componentMap = {
    'tr-indicator-type-a': defineAsyncComponent(
      () =>
        import(
          '~/components/trendsreport/pdf/templates/TrIndicatorTypeBTemplate.vue'
        )
    ),
    'tr-indicator-type-b': defineAsyncComponent(
      () =>
        import(
          '~/components/trendsreport/pdf/templates/TrIndicatorTypeBTemplate.vue'
        )
    ),
    'tr-at-a-glance': defineAsyncComponent(
      () =>
        import(
          '~/components/trendsreport/pdf/templates/TrAtAGlanceTemplate.vue'
        )
    ),
    'tr-trends-10': defineAsyncComponent(
      () =>
        import('~/components/trendsreport/pdf/templates/TrTrends10Template.vue')
    ),
    'tr-leading-indicator': defineAsyncComponent(
      () =>
        import(
          '~/components/trendsreport/pdf/templates/TrLeadingIndicatorTemplate.vue'
        )
    ),
    'tr-executive-summary': defineAsyncComponent(
      () =>
        import(
          '~/components/trendsreport/pdf/templates/TrExecutiveSummaryTemplate.vue'
        )
    ),
    'tr-global-at-a-glance': defineAsyncComponent(
      () =>
        import('~/components/trendsreport/pdf/templates/TrGlobalAtAGlance.vue')
    ),
  };

  export default {
    name: 'TrendsReportPDFComponent',
    components: {},
    props: {
      cwa_data: {
        Type: Object,
        required: false,
      },
      report: {
        Type: Object,
        required: true,
      },
      app_url: {
        type: String,
        required: true,
      },
    },
    setup(props) {
      const template = props.cwa_data
        ? componentMap[props.report.report_type.template.slug]
        : defineAsyncComponent(
            () =>
              import(
                '~/components/trendsreport/pdf/templates/XmlTrTemplate.vue'
              )
          );

      const publishDate = computed(() => {
        return props.report.published_date
          ? moment(props.report.published_date).format('MMMM DD, YYYY')
          : props.report.issue
            ? moment(props.report.issue).format('MMMM DD, YYYY')
            : moment(props.report.updated_at).format('MMMM DD, YYYY');
      });

      const section = computed(() => {
        return props.report.report_type.trgroup.name.split(' ')[0];
      });

      return {
        template,
        section,
        publishDate,
      };
    },
  };
</script>

<style lang="scss" scoped>
  .trendsreport-pdf-component {
    font-family: 'Open Sans', sans-serif !important;
    padding: 0 120px;
  }
</style>
